import { useEffect, useState } from 'react';
import { BatchDetails } from '../../../shared/types/batchDetails.ts';
import { ModalDialog } from '../../components/modalDialog.tsx';
import { MeasureIntervalState } from '../../types/sharedTypeImpl.ts';
import { trpcClient } from '../../utils/trpc/trpc.ts';


interface Props {
    measureIntervalRow: MeasureIntervalState;
    onClose: () => void;
}

export function BatchDetailsDialog({
    measureIntervalRow,
    onClose,
}: Props) {

    const [targetQuantity, setTargetQuantity] = useState<string>('');
    const [orderNumber, setOrderNumber] = useState<string>(''.toString());


    useEffect(() => {
        setTargetQuantity((measureIntervalRow.targetQuantity ?? '').toString())
        setOrderNumber((measureIntervalRow.orderNumber ?? '').toString())
    }, [measureIntervalRow]);

    function handleKeyDown(e: React.KeyboardEvent) {
        if (e.key === 'Enter') {
            handleSubmit();
        }
    }

    async function handleSubmit() {
        if (!measureIntervalRow) return;

        if (!measureIntervalRow.product || !measureIntervalRow.batchStart) {
            alert('Invalid batch.');
            return;
        }

        const targetQuantityParsed = targetQuantity ? parseInt(targetQuantity) : null;
        if (!targetQuantityParsed) {
            alert('Invalid target quantity.');
            return;
        }

        const batchDetails = {
            equipment: measureIntervalRow.equipment,
            product: measureIntervalRow.product,
            batchStart: measureIntervalRow.batchStart,
            orderNumber,
            targetQuantity: targetQuantityParsed,
        };

        const result = await upload(batchDetails);
        if (result) {
            // onValuesChanged();
        }
        onClose();
    }

    async function upload(
        batchDetails: BatchDetails,
    ): Promise<boolean> {
        try {
            await trpcClient.batchDetails.set.mutate(batchDetails);
            return true;
        } catch (error) {
            alert(`Setting values failed. ${(error as Error).message}`);
            console.log(error);
            return false;
        }
    }


    if (!measureIntervalRow) return null;

    const equipmentAndProduct = [measureIntervalRow.displayName, measureIntervalRow.product].filter(it => it != null).join(' - ');
    return (
        <ModalDialog
            frameStyle={{ minWidth: '360px' }}
            isOpen={true}
            onCancel={onClose}
        >
            <div>{equipmentAndProduct}</div>

            <div className='dialog-form__field--with-margins' >
                <div>Order number</div>
                <input
                    className='dialog-form__input'
                    type={'text'}
                    value={orderNumber}
                    onChange={e => setOrderNumber(e.target.value)}
                    onKeyDown={handleKeyDown}
                />
            </div>

            <div className='dialog-form__field--with-margins' >
                <div>Target quantity</div>
                <input
                    className='dialog-form__input'
                    type={'number'}
                    value={targetQuantity}
                    onChange={e => setTargetQuantity(e.target.value)}
                    onKeyDown={handleKeyDown}
                />
            </div>

            <div className='dialog--button-bar'>
                <button onClick={onClose}>Cancel</button>
                <button onClick={handleSubmit}>Submit</button>
            </div>
        </ModalDialog >
    )
}
